import {Component, OnInit} from '@angular/core';
import {ModalController, NavParams} from "@ionic/angular";
import {PostModel} from "../../models/post.model";
import {ApiResponse} from "../../services/utils";
import {PostService} from "../../services/post/post.service";
import {GlobalService} from "../../services/global/global.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-moment-selected-action-point',
    templateUrl: './moment-selected-action-point.component.html',
    styleUrls: ['./moment-selected-action-point.component.scss'],
    standalone: false
})
export class MomentSelectedActionPointComponent implements OnInit {
  actionPointId: number;
  actionPoint: PostModel;

  constructor(
    private navParams: NavParams,
    private postService: PostService,
    private modalCtrl: ModalController,
    private globalService: GlobalService,
    private translate: TranslateService
  ) {
    this.actionPointId = this.navParams.get('actionPointId');
  }

  ngOnInit() {
    this.getSelectedActionPoint(this.actionPointId);
  }

  getSelectedActionPoint(actionPointId: number) {
    this.postService.apiGetSingleActionPoint(actionPointId).subscribe((result: ApiResponse) => {
      if (result.status === true) {
        this.actionPoint = result.data;
      }
    });
  }

  unassignActionPoint() {
    this.modalCtrl.dismiss(null, 'unassigned');

    this.globalService.presentToast(this.translate.instant('txt_action_point_detached'));


  }

}
